import React from 'react';
import EventsCalendar from '../../components/EventsCalendar';
import { EVENTS_CALENDAR_PATTERN, IFRAME_PATTERN } from '../../utils/constants';
import useArticle from '../../utils/useArticle';
import './index.scss';
import { sanitizeHtml } from '../../utils/commonFunctions';

const ContentPart = ({ contentPart, iframeUrl }) => {
    const { replaceContent } = useArticle();

    switch (contentPart) {
        case EVENTS_CALENDAR_PATTERN:
            return <EventsCalendar />;
        case IFRAME_PATTERN:
            return iframeUrl ? (
                <iframe
                    className="articleIframe"
                    src={iframeUrl}
                    loading="lazy"
                ></iframe>
            ) : null;
        default:
            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(replaceContent(contentPart)),
                    }}
                />
            );
    }
};

export default ContentPart;
